export const API_GEO_SEARCH_LIMIT = 5000;
export const API_ADDRESS_SEARCH_LIMIT = 2000;
export const API_REQUEST_SHOP_TYPE = 3;
export const API_CATALOG_TYPE = 1;
